export default __webpack_public_path__ + "static/Campaign-5ce7c0bd1c5d2ed786fefe925dfbe6e9.png";